export default "__VITE_ASSET__07OSCCZo__"